import { WebReportEvent } from '@slardar/sdk-web';
import { BaseHandler } from '../../types';

export default abstract class BasePlugin implements BaseHandler {
  next: BasePlugin | undefined;

  constructor() {
    if (new.target === BasePlugin) {
      throw new Error('BasePlugin can not be initialized directly');
    }
  }

  setNext(handler: BasePlugin) {
    this.next = handler;
    return handler;
  }

  handleErrorEvent(event: WebReportEvent): WebReportEvent | false {
    if (!this.shouldHandle(event)) {
      if (this.next) {
        return this.next.handleErrorEvent(event);
      }
      return event;
    }
    return this.handle(event);
  }

  abstract handle(event: WebReportEvent): WebReportEvent | false;

  abstract shouldHandle(event: WebReportEvent): event is WebReportEvent;
}
